<script lang="ts">
  import { FormGroup, SelectableTile, TextInput } from 'carbon-components-svelte';

  import type { AttributeOptions } from '../modules/attributes';

  type Props = {
    attributes: AttributeOptions;
  };
  const { attributes }: Props = $props();
</script>

<FormGroup>
  <SelectableTile data-testid="bool--autoplay" bind:selected={attributes.autoplay}>Autoplay</SelectableTile>
  <SelectableTile data-testid="bool--bitrate" bind:selected={attributes.bitrateLimitEnabled}
    >Bitrate Limit</SelectableTile>
  <SelectableTile data-testid="bool--cta-button" bind:selected={attributes.callToActionButton}
    >Call to Action Button</SelectableTile>
  <SelectableTile data-testid="bool--controls" bind:selected={attributes.controls}>Controls</SelectableTile>
  <SelectableTile data-testid="bool--chunked-transfer" bind:selected={attributes.chunkedTransfer}
    >Chunked Transfer</SelectableTile>
  <SelectableTile data-testid="bool--background" bind:selected={attributes.background}>Background Mode</SelectableTile>
  <SelectableTile data-testid="bool--debug" bind:selected={attributes.debug}>Debug Mode</SelectableTile>
  <SelectableTile data-testid="bool--ios" bind:selected={attributes.isIos}>Ios Mode</SelectableTile>
  <SelectableTile data-testid="bool--loop" bind:selected={attributes.loop}>Loop</SelectableTile>
  <SelectableTile data-testid="bool--scrub" bind:selected={attributes.scrubBar}>Scrub Bar</SelectableTile>
  <SelectableTile data-testid="bool--mute" bind:selected={attributes.mute}>Mute</SelectableTile>
</FormGroup>
<FormGroup legendText="Start Position in Seconds">
  <TextInput
    data-testid="string--start-pos"
    size="sm"
    bind:value={attributes.startPos}
    placeholder="Enter start pos..."
    type="number" />
</FormGroup>
